<template>
<div class="departments_wrap fadeIn fast animated" v-if="show">
	<div class="dep_list_wrapper slideInLeft faster animated ">
		<div class="dep_list_heading">
			<div class="header_departments">
				<p v-if="firstName">{{'Hello ' +  firstName}}</p>
				<p v-else>{{'Hello ' }}</p>
			</div>
		</div>
		<div class="dep_list_inner" id="results">
			<div v-if="showProfile" class="mobile_nav_list">
				<div v-if="!_isAuth" class="dep_list_single" @click="toggleVisibility()">
					<router-link :to="{name:'Login'}" class="dls_ttl">Login</router-link>
				</div>
				<div class="dep_list_single" @click="toggleVisibility()">
					<router-link :to="{name:'Account'}" class="dls_ttl">My Profile</router-link>
				</div>
				<div class="dep_list_single" @click="toggleVisibility()">
					<router-link :to="{name:'Orders'}" class="dls_ttl">My Orders</router-link>
				</div>
				<div class="dep_list_single" @click="toggleVisibility()">
					<router-link class=" dls_ttl" :to="_isAuth ? {name:'Favorites'} : {name:'GuestFavorites'}">My Favorites</router-link>
				</div>
				<div class="dep_list_single" @click="toggleVisibility()">
					<router-link class="dls_ttl" :to="{name:'BueAgain'}">Quick Reorder</router-link>
				</div>
				<div class="dep_list_single" @click="toggleVisibility()">
					<router-link class="dls_ttl" :to="{name:'DigitalLibary'}">Digital Libary</router-link>
				</div>
				<div class="dep_list_single" @click="toggleVisibility()">
					<router-link class="dls_ttl" :to="{name:'Subscriptions'}">Subscriptions</router-link>
				</div>
				<div class="dep_list_single" @click="toggleVisibility()">
					<router-link class="dls_ttl" :to="{name:'ContactUs'}">Help</router-link>
				</div>
				<div v-if="_isAuth" class="dep_list_single">
					<p class="dls_ttl" @click="signOut()">Sign Out</p>
				</div>
			</div>
			<div v-if="!path.length" class="dep_list_sec_head">
				<p class="dlsh_ttl">Departments</p>
			</div>
			<span v-if="path.length">
				<div class="dep_list_single" @click="prev">
					<img src="/img/right_grey.svg" :style="{transform: 'rotate(180deg)'}">
					<p class="dls_ttl margin">Back</p>
				</div>
				<div
					class="dep_list_single"
					@click="showAll()"
				>
					<p
						class="dls_ttl"
						:style="{color: '#016145'}"
					>
						{{active.name}} - Show All
					</p>
				</div>
			</span>
			<span v-for="(category, index) in current" :key="index">
				<!-- <router-link v-if="category.children.length == 0" :to="category.value"> -->
					<div
						class="dep_list_single"					
						@click="next(index)"
					>
						<p class="dls_ttl">{{category.name}}</p>
						<img src="/img/right_grey.svg" v-if="category.children.length > 0">
					</div>
				<!-- </router-link> -->
				<!-- <div v-else
					class="dep_list_single"					
					@click="next(index)">
					<p class="dls_ttl">{{category.name}}</p>
						<img src="/img/right_grey.svg">
				</div> -->
			</span>
		</div>
	</div>
	<div class="dep_overlay" @click="toggleVisibility">
		<p class="dep_overlay_ex">
			<svg xmlns="http://www.w3.org/2000/svg" width="18.635" height="18.634" viewBox="0 0 23.635 23.634"><defs></defs><path class="a" d="M49.982,28.114l-1.766-1.766L38.165,36.4,28.114,26.348l-1.766,1.766L36.4,38.165,26.348,48.216l1.766,1.766L38.165,39.931,48.216,49.982l1.766-1.766L39.931,38.165Z" transform="translate(-26.348 -26.348)"/></svg>
		</p>
	</div>
</div>
</template>

<script>
import {mapGetters,mapActions} from "vuex";
    export default {
		
        data() {
            return {
				categories: [],
				show: false,
				current: [],
				path: '',
				showProfile:true
            }
		},

        mounted() {
            axios('/api/categories')
                .then(success => {
					this.categories = success.data;
					this.current = this.categories
                })
                .catch(err=>{
					handleError(err,this.$router)
				})
		},
		methods: {
			 ...mapActions({_logout:'customer/logout'}),
			signOut(){
				this.$root.$refs["spinner"].startSpinner();
				this._logout().then(()=>{
					this.toggleVisibility()
					this.$router.push({name:'Home'});
				}).catch(err=>{
					this.$root.$refs["spinner"].stopSpinner()
					handleError(err,this.$router)
				}).then(()=> this.$root.$refs["spinner"].stopSpinner());
			},
			toggleVisibility() {
				this.show = !this.show
				this.path = ''
				this.current = this.categories
			},
			next(index) {
				if (this.current[index].children && this.current[index].children.length) {
					this.path += `[${index}]['children']`
					this.current = this.current[index].children
					let el = document.getElementById('results')
					el.classList.add('slideInRight','animated','faster')
					setTimeout(()=>{
						el.classList.remove('slideInRight','animated','faster')
					},200)
				} else {
					if(this.current[index].value){
						this.$router.push(this.current[index].value).catch(err=>{})
						this.toggleVisibility()
					}		
				}
			},
			prev() {
				this.path = this.path.replace(/\[[^\][]*\]$/, '').replace(/\[[^\][]*\]$/, '')
				this.current = eval(`this.categories` + this.path)
				let el = document.getElementById('results')
				el.classList.add('slideInLeft','animated','faster')
				setTimeout(()=>{
					el.classList.remove('slideInLeft','animated','faster')
				},200)
			},
			showAll() {
				this.$router.push(this.active.value).catch(err=>{})
				this.toggleVisibility();
			},
			escape(event){
				if(event.keyCode == 27){
					this.toggleVisibility();			
				}	
			}
		},
		computed: {
			...mapGetters({
				firstName: "customer/getFirstName",
				_isAuth:"customer/isAuth"}),
			active: function() {
				return eval(`this.categories` + this.path.replace(/\[[^\][]*\]$/, ''))
			}
		},
		
		watch:{
			show(){
				if(this.show){
					document.body.classList.add('no_scroll')
					document.addEventListener("keydown",this.escape);
				}else{
					document.body.classList.remove('no_scroll')
					document.removeEventListener("keydown",this.escape);
				}
			},
			path(){
				if(this.path){
					this.showProfile = false
				}else{
					this.showProfile = true
				}
			}
		}
    }
</script>
<style scoped>
.a{fill:#fff;}
.margin{
	margin-left: 10px;
	margin-right: auto;
}
.delay{
	animation-delay: 200ms;
}
.faster{
	animation-duration: 200ms;
}
.fast{
	animation-duration: 150ms;
}
@keyframes slideInRight {
  from {
    transform: translate3d(100%, 0, 0);
    visibility: hidden;
  }

  to {
	transform: translate3d(0, 0, 0);
	visibility: visible;
  }
}

._slideInRight {
  animation-name: slideInRight;
}

</style>




// WEBPACK FOOTER //
// resources/js/components/categories/CategoriesList.vue